export default __webpack_public_path__ + "static/media/sh2_9.4798acbd.jpg";